import jQuery from 'jquery';

export default function ($ = jQuery) {
  const blockEl = document.querySelector('.block-booking');
  if (!blockEl) {
    return;
  }

  const panoramaSidebarContainer = document.getElementById('panoramaSidebarContainer');

  const methods = {
    updatePanoramaText: function (location) {
      if (!panoramaSidebarContainer)
        return false;
      if (!location || (location !== 'extra-additionalproducts' && location !== 'mytrips')) {
        location = 'booking';
      }
      $('.panorama-text', panoramaSidebarContainer).hide();
      $('#panoramaText-' + location).show();
    },

    /*
     * Handle events for changing URL on the panorama view.
     */
    changePanoramaView: function (e) {
      let view = $(this).is('select') ? $(this).val() : $(this).attr('href');

      if (view) {
        view = view.replace(/\/?#\//, '');
        window.location.hash = view;
      }
    }
  };

  $('select.js-changePanoramaView').on('change', methods.changePanoramaView);

  $(window).on('hashchange', function() {
    methods.updatePanoramaText(window.location.hash.replace(/\/?#\//, ''));
  });

  methods.updatePanoramaText(window.location.hash.replace(/\/?#\//, ''));
};
